module.exports = __webpack_public_path__ + "img/banner2_9.98713fd9.png";